// src/router/index.ts  → router do APP PRIVADO
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

// privadas
import { guestRoutes } from '@/modules/guest/routes' // /guest (privado)
import { expertRoutes } from '@/modules/expert/routes' // /expert (privado)
import { registrationRoutes } from '@/modules/guest/registration/routes'

// públicas (array de rotas)
import { guestPublicRoutes } from '@/modules/guest/routes/guest-public'

const NotFound = () => import('@/modules/notfound/views/Home.vue')

const routes: RouteRecordRaw[] = [
  // --- REDIRECT RAIZ (pega "/" e também caminho vazio "")
  {
    path: '/',
    alias: [''], // ← cobre o caso “sem nada”
    redirect: { name: 'guest' },
    meta: { public: true },
  },

  // --- PRIVADAS
  ...guestRoutes, // /guest
  ...expertRoutes, // /expert
  ...registrationRoutes,

  // --- PÚBLICAS (/guest-events, etc.)
  // Mantidas DEPOIS pra não sobrepor o redirect raiz
  ...guestPublicRoutes,

  // 404 real
  {
    path: '/404',
    name: 'not-found',
    component: NotFound,
    meta: { public: true },
  },

  // qualquer outra → 404
  { path: '/:pathMatch(.*)*', redirect: '/404' },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

export default router
export { router }
